let exports = {
   addDirector:{
      forms:[
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'firstName',
            validation: 'required|min:3|max:30', label: 'First Name', placeholder: 'Provide the First Name',
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'lastName',
            validation: 'required|min:3|max:30', label: 'Last Name', placeholder: 'Provide the Last Name',
         },
         {
            type: 'textarea', class: 'col-12', model: 'description', rows: '4', validation: 'required|min:10|max:500', 
            label: 'Description', placeholder: 'Provide a description'
         },
      ],
      table:{
         icon: 'fa fa-sitemap',
         title: 'Directors',
         table_fields: [
            { name: 'First Name', align: 'c' },
            { name: 'Last Name', align: 'c' },
            { name: 'Actions', align: 'c' }
         ],
         search_fields: ["firstName", "lastName"],
         row_data: [
            { type: 'text', field: 'firstName', class: 'bold center' },
            { type: 'text', field: 'lastName', class: 'small center' },
            {
               type: 'action', field: 'name', class: 'center', icon: '', actions: [
                  // {type: 'title', title: 'Actions'},
                  { type: 'menu', title: 'View', event: 'table:view' },
                  { type: 'menu', title: 'Delete', event: 'table:delete', icon: 'fa-trash-alt' },
               ]
            },
         ]
      }
   }
}

async function queryUsers(query){
   try {

      let users = [
         { firstName: 'James', lastName: 'Kamau', age: 20 },
         { firstName: 'John', lastName: 'Kimbo', age: 20 },
         { firstName: 'Mercy', lastName: 'Wanjiku', age: 20 },
         { firstName: 'Hellen', lastName: 'Anyango', age: 20 },
      ]
      
      let data =  users.filter((user) => {
         if (user.firstName.toLowerCase().includes(query.toLowerCase()) || user.lastName.toLowerCase().includes(query.toLowerCase())){
            return true
         }
         return false
      }).map(item => {
         return { val: item, label: `${item.firstName} ${item.lastName}`}
      });
      
      console.log(data)
      Event.$emit('remote:receivedData', { formName: 'add_user', name: 'users',data})
      return data;
   } catch (err) { throw err }
}

let forms = {
   formTable: {
      icon: 'fa fa-user',
      title: 'Add User',
      subtitle: 'Provide User Details',
      forms: [
         {
            type: 'form-table', forms: exports.addDirector.forms, table: exports.addDirector.table, label: 'Directors', model: 'directors',
         }
      ]
   },
   add_user: {
      icon: 'fa fa-user',
      title: 'Add User',
      subtitle: 'Provide User Details',
      forms: [
         // {
         //    type: 'remote', class: 'col-12 col-md-6', model: 'user', filterable: true, clearable: true,
         //    options: [], validation: 'required', label: 'User', remote: queryUsers, remoteName: 'users'
         // },
         {
            type: 'mobile', class: 'col-12 col-md-6', model: 'mobileNo', filterable: true,validation: 'required', label: 'Mobile Number'
         },
         {
            type: 'form-table', forms: exports.addDirector.forms, table: exports.addDirector.table, class: 'col-12 col-md-6',
            label: 'Directors', model: 'directors',
         },
         {
            type: 'slider', step: 10, model: 'temperature', label: 'Temperature', show_stops: true, class: 'col-12', validation: 'required'
         },
         {
            type: 'slider', step: 10, model: 'temperature_range', label: 'Temperature Range', show_stops: true, range: true,
            class: 'col-12'
         },
         {
            type: 'rate', allow_half: true, model: 'rate', label: 'Rating',
            icon: 'heart', class: 'col-12 col-md-6', validation: 'required'
            // character: "好"
         },
         {
            type: 'color', hue: true, alpha: true, model: 'selectedColor', label: 'Default Color', recommend: false,
            colors: ['#db2828', '#f2711c', '#21ba45', '#009C95',], class: 'col-12 col-md-6', validation: 'required'
         },
         {
            type: 'datepicker', form_type: 'daterange', format: 'dd-MM-yyyy', placement: 'bottom-end', placeholder: 'Select a date',
            model: 'duration', label: 'Duration', class: 'col-12 col-md-6', validation: 'required'
            // start_date: new Date(2000,0,1)
         },
         {
            type: 'datepicker', form_type: 'date', format: 'dd-MM-yyyy', placement: 'bottom-end', placeholder: 'Select a date',
            model: 'date', label: 'Duration', class: 'col-12 col-md-6', validation: 'required'
         },
         {
            type: 'checkbox', class: 'col-12 custom-check', model: 'terms', validation: 'required',
            label: 'I agree to the <a href="#">Terms, Privacy Policy</a> and <a href="#">Fees</a>'
         },
         {
            type: 'radio', class: 'col-12 funkyradio', elClass: 'funkyradio', model: 'client_type', label: 'Users', validation: 'required',
            options: [
               { val: { type: 'Hello', subtype: '728377' }, label: 'Individual', id: '728377' },
               { val: { type: 'Hello', subtype: '878923' }, label: 'Sole Propriator', id: '878923' },
               { val: { type: 'Hello', subtype: '89834' }, label: 'Business', id: '89834' },
               { val: { type: 'Hello', subtype: '9239723' }, label: 'Government', id: '9239723' }
            ],classes: {radioRow: 'row', radioCol: 'col-12 col-md-6 col-lg-4'}
         },
         {
            type: 'label', label: 'This is a label', class: 'col-12 col-md-6'
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'id_types', filterable: true, clearable: true,
            multiple: true, max_tag_count: 1,
            options: [
               { val: { type: 'Hello', subtype: '728377' }, label: 'Individual', id: '728377' },
               { val: { type: 'Hello', subtype: '878923' }, label: 'Sole Propriator', id: '878923' },
               { val: { type: 'Hello', subtype: '89834' }, label: 'Business', id: '89834' },
               { val: { type: 'Hello', subtype: '9239723' }, label: 'Government', id: '9239723' }
            ], validation: 'required', label: 'ID Type'
         },
         {
            type: 'textarea', class: 'col-12', model: 'description', rows: '4',
            validation: 'required|min:10|max:500', label: 'Description', placeholder: 'Provide a description'
         },
         {
            type: 'text', form_type: 'number', class: 'col-12 col-md-6', model: 'from',
            validation: 'required|numeric|min:10|max:30', label: 'From', placeholder: 'Provide the value', err: ''
         },
         {
            type: 'location', class: 'col-12 col-md-6', model: 'location',validation: 'required', label: 'School Location', 
            placeholder: 'Provide the school location'
         },
         {
            type: 'upload', class: 'col-12', model: 'mou',validation: 'required', label: 'MOU', 
            accept: 'image/*',multiple:true
         },
         { type: 'button', btnClass: 'btnLong', class: 'col-12', model: 'submit', label: 'Click Me!'}
      ],
   },
   general_configs: {
      icon: 'fa fa-tools',
      title: 'General',
      subtitle: 'General Configs',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12', model: 'ref',
            validation: 'required|min:3|max:150', label: 'Internal Ref'
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'code',
            validation: 'required|min:3|max:150', label: 'Code'
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'name',
            validation: 'required|min:3|max:150', label: 'Name'
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'sub_class',
            options: [
               { val: 'General', label: 'General' },
               { val: 'Motor', label: 'Motor' },
            ],
            validation: 'required', label: 'Sub Class'
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'cover_type',
            options: [
               { val: 'COMPREHENSIVE', label: 'Comprehensive' },
               { val: 'THIRD_PARTY', label: 'Third Party' },
            ],
            validation: 'required', label: 'Cover Type'
         },
         { type: 'label', label: 'Accepted Currency', class: 'col-12' },
         {
            type: 'checkbox', class: 'col-12 col-md-4', model: 'cur_kes',
            label: 'KES'
         },
         {
            type: 'checkbox', class: 'col-12 col-md-4', model: 'cur_usd',
            label: 'USD'
         },
         {
            type: 'checkbox', class: 'col-12 col-md-4', model: 'cur_gbp',
            label: 'GBP'
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'minimum_premium',
            validation: 'required|min:1|max:8|numeric', label: 'Minimum Premium'
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'policy_term',
            options: [
               { val: 'DAILY', label: 'Daily' },
               { val: 'MONTHLY', label: 'Monthly' },
               { val: 'WEEKLY', label: 'Weekly' },
               { val: 'YEARLY', label: 'Yearly' },
            ],
            validation: 'required', label: 'Policy Term'
         },
         {
            type: 'text', form_type: 'text', label: 'Description', model: 'description',
            validation: 'required|min:30|max:500', class: 'col-12'
         },
      ],
   },
   add_charges: {
      icon: 'fa fa-funnel-dollar',
      title: 'Charges',
      subtitle: 'Charges and Requirements',
      forms: [
         {
            type: 'select', class: 'col-12 col-md-6', model: 'requirements',
            options: [
               { val: 'SELECT_ALL', label: 'Select All' },
            ],
            validation: 'required', label: 'Requirements', multiple: true
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'charges',
            options: [
               { val: 'SELECT_ALL', label: 'Select All' },
            ],
            validation: 'required', label: 'Charges', multiple: true
         },
      ],
   },
   target_market: {
      icon: 'fa fa-lightbulb',
      title: 'Market',
      subtitle: 'Target Market Configs',
      forms: [
         {
            type: 'select', class: 'col-12 col-md-6', model: 'religion',
            options: [
               { val: 'CHRISTIAN', label: 'Christian' },
               { val: 'MUSLIM', label: 'Muslim' },
               { val: 'HINDU', label: 'Hindu' },
               { val: 'OTHER', label: 'Other' },
               { val: 'ALL', label: 'All' },
            ],
            validation: 'required', label: 'Religion'
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'age',
            options: [
               { val: '18-28', label: '18-28' },
               { val: '28-38', label: '28-38' },
               { val: '38-48', label: '38-48' },
               { val: '48-58', label: '48-58' },
               { val: 'OVER-58', label: 'Over 58' },
               { val: 'ALL', label: 'All' },
            ],
            validation: 'required', label: 'Age'
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'gender',
            options: [
               { val: 'MALE', label: 'Male' },
               { val: 'FEMALE', label: 'Female' },
               { val: 'ALL', label: 'All' },
            ],
            validation: 'required', label: 'Gender'
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'marital_status',
            options: [
               { val: 'SINGLE', label: 'Single' },
               { val: 'MARRIED', label: 'Married' },
               { val: 'ALL', label: 'All' },
            ],
            validation: 'required', label: 'Marital Status'
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'client_type',
            options: [
               { val: 'ALL', label: 'All' },
            ], validation: 'required', label: 'Client Type'
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'nationality',
            options: [
               { val: 'RESIDENT', label: 'Resident' },
               { val: 'NON_RESIDENT', label: 'Non Resident' },
               { val: 'ALL', label: 'All' },
            ],
            validation: 'required', label: 'Nationality'
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'client_subtype',
            options: [
               { val: 'ALL', label: 'All' },
            ], validation: 'required', label: 'Client Subtype'
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'employment_status',
            options: [
               { val: 'SELF', label: 'Self' },
               { val: 'EMPLOYED', label: 'Employed' },
               { val: 'ALL', label: 'All' },
            ],
            validation: 'required', label: 'Employment Status'
         },
      ],
   },
}

let tables = {
   product: {
      icon: 'fa fa-sitemap',
      title: 'Products',
      table_fields: [
         { name: 'Image', align: 'l' },
         { name: 'Name', align: 'c' },
         { name: 'Code', align: 'c' },
         { name: 'Class', align: 'c' },
         { name: 'Sub-Class', align: 'c' },
         { name: 'Status', align: 'c' },
         { name: 'Actions', align: 'c' }
      ],
      search_fields: ["product_name", "product_code", "class.0.class_code"],
      row_data: [
         { type: 'image', field: 'logo', class: 'left' },
         { type: 'text', field: 'product_name', class: 'bold center' },
         { type: 'text', field: 'product_code', class: 'small center' },
         { type: 'text', field: 'class.0.class_code', class: 'small center' },
         { type: 'text', field: 'class.0.sub_class_code', class: 'small center' },
         { type: 'status', field: 'status', class: 'center' },
         {
            type: 'action', field: 'name', class: 'center', icon: '', actions: [
               // {type: 'title', title: 'Actions'},
               { type: 'menu', title: 'View', event: 'product:view' },
               { type: 'menu', title: 'Edit', event: 'product:edit', icon: 'fa-edit' },
               { type: 'menu', title: 'Delete', event: 'product:delete', icon: 'fa-trash-alt' },
               { type: 'menu', title: 'Show Accounts', event: 'product:accounts', icon: 'fa-file-invoice-dollar' },
            ]
         },
      ]
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}